import { render, staticRenderFns } from "./VideoTag.vue?vue&type=template&id=66a39286&scoped=true&"
import script from "./VideoTag.vue?vue&type=script&lang=js&"
export * from "./VideoTag.vue?vue&type=script&lang=js&"
import style0 from "./VideoTag.vue?vue&type=style&index=0&id=66a39286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a39286",
  null
  
)

export default component.exports